import { useState, useEffect } from "react";
import SliderCard from "./SliderCard";
import SliderArrow from "./SliderArrow";

const Slider = ({
  name,
  setSliderRef = () => {},
  cards,
  sliderBreakingPoint = 992,
  gapSize = 16,
}) => {
  const [translation, setTranslation] = useState(0);
  const [rightEndReached, setRightEndReached] = useState(true);

  function slide(direction) {
    const sliderContainer = document.querySelector(`.slider-container-${name}`);
    const slideList = document.querySelector(`#slide-list-${name}`);
    const sliderCardWidth = slideList.firstChild.offsetWidth;

    let newTranslation;

    if (direction > 0) {
      newTranslation =
        Math.floor(
          (translation + direction * sliderContainer.clientWidth) / (sliderCardWidth + gapSize / 2),
        ) *
        (sliderCardWidth + gapSize);
    } else {
      newTranslation =
        Math.ceil(
          (translation + direction * sliderContainer.clientWidth) / (sliderCardWidth + gapSize / 2),
        ) *
        (sliderCardWidth + gapSize);
    }

    setTranslation(
      Math.max(Math.min(newTranslation, slideList.clientWidth - sliderContainer.clientWidth), 0),
    );

    setRightEndReached(newTranslation + sliderContainer.clientWidth >= slideList.clientWidth);
  }

  function displayCards() {
    return cards?.map((card, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <SliderCard key={`${name}-slider-card-${index}`}>{card}</SliderCard>
    ));
  }

  useEffect(() => {
    function checkForRightEndReached() {
      const sliderContainer = document.querySelector(`.slider-container-${name}`);
      const slideList = document.querySelector(`#slide-list-${name}`);

      setRightEndReached(sliderContainer.clientWidth >= slideList.clientWidth);
    }

    function checkForBreakingPointReached() {
      const bodyWidth = document.body.clientWidth;
      if (bodyWidth < sliderBreakingPoint) {
        setTranslation(0);
        setRightEndReached(false);
      } else {
        const sliderContainer = document.querySelector(`.slider-container-${name}`);
        if (sliderContainer) sliderContainer.scrollTo({ left: 0, behavior: "smooth" });
      }
    }
    checkForRightEndReached();
    window.addEventListener("resize", checkForBreakingPointReached);

    return () => window.removeEventListener("resize", checkForBreakingPointReached);
  }, [cards, name, sliderBreakingPoint]);

  if (!cards || cards?.length <= 0) return null;

  return (
    <section>
      <div className={`slider-wrapper slider-wrapper-${name}`}>
        <SliderArrow
          direction={-1}
          slide={slide}
          endReached={translation === 0}
          name={name}
        />
        <div
          className={`slider-container slider-container-${name}`}
          ref={(ref) => setSliderRef(ref)}
        >
          <div
            id={`slide-list-${name}`}
            className="d-flex"
            style={{
              transform: `translate(${-translation}px)`,
              transition: "all 0.5s ease-in-out",
              gap: `${gapSize}px`,
            }}
          >
            {displayCards()}
          </div>
        </div>
        <SliderArrow
          direction={1}
          slide={slide}
          endReached={rightEndReached}
          name={name}
        />
      </div>
    </section>
  );
};

export default Slider;
